import React from 'react'

const Popup = ({ children, style, className }: { children: React.ReactNode, className?: string, style?: React.CSSProperties }) => {
  return (
    <div className={`bg-gray-750 w-full mx-8 p-5 rounded-xl border ${className}`} style={{ boxShadow: '0px 0px 1000px 1000px #0004', zIndex: 100, ...style }}>
      {children}
    </div>
  )
}

export default Popup